import React from 'react'

type Props = {
    className?          : string

    size?               : '13' | '14' | '16'

    isChecked?          : boolean
    disabled?           : boolean

    onClick?            : {(value:boolean, e:any):void}
    onDisabledClick?    : {(value:boolean, e:any):void}
}

export default function UI5CheckBox(props:Props) {
    const size = _.get(props, 'size', '16')

    const onClick = (e:any) => {
        if (!props.disabled && props.onClick) {
            e.preventDefault()
            e.stopPropagation()
            props.onClick(!props.isChecked,e);
        } else if (props.disabled && props.onDisabledClick) {
            props.onDisabledClick(!!props.isChecked,e)
        }
    }

    const classes = Classes('ui5-cb', 's-{0}'.f(size), props.className, {
        selected: props.isChecked,
        disabled: props.disabled
    })

    return <div className={classes} onClick={onClick}/>;
}